import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Formik } from "formik";
import * as Yup from "yup";
import AlertComponent from "../components/AlertComponent";
import { deleteRole, editRole, postRole } from "../redux/action/roleAction";
import ModalComponent from "../components/ModalComponent";
import { openForm } from "../redux/slice/roleSlice";

const FormRole = ({ param }) => {
  const { idRole, dataByIdRole, isOpenForm, state } = useSelector(
    (state) => state.role
  );
  const dispatch = useDispatch();

  const initialValues = {
    name: idRole === '' ? '' : dataByIdRole.name,
    descr: idRole === '' ? '' : dataByIdRole.descr,
  };
  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Nama is required!"),
    descr: Yup.string().required("Deskripsi is required!"),
  });

  const handleFormSubmit = async (values) => {
    if (state === "add") {
      param.data = values;
      // console.log(param.data);
      dispatch(postRole(param));
    } else if (state === "edit") {
      param.data = values;
      param.id = idRole;
      dispatch(editRole(param));
    } else {
      param.id = idRole;
      dispatch(deleteRole(param));
    }
  };

  return state === "delete" ? (
    <AlertComponent
      show={isOpenForm}
      close={() => dispatch(openForm({ open: false, state: "close" }))}
      action={() => handleFormSubmit()}
    />
  ) : (
    <ModalComponent
      title={state === "add" ? "TAMBAH ROLE" : "EDIT ROLE"}
      show={isOpenForm}
      close={() => dispatch(openForm({ open: false, type: "close" }))}
      idForm="role-form"
    >
      <Formik
        onSubmit={handleFormSubmit}
        initialValues={initialValues}
        validationSchema={validationSchema}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
        }) => (
          <form onSubmit={handleSubmit} id="role-form">
            <div className="row align-items-center" style={{ color: "white" }}>
              <div className="form-group row mb-3">
                <label htmlFor="staticEmail" className="col-sm-2 col-form-label">Name</label>
                <div style={{ paddingBottom: '10px'}}>
                    <input onChange={handleChange}
                        type="text"
                        name="name"
                        id="name"
                        className='form-control'
                        value={values.name}
                        validation={{ touched: touched.name, errors: errors.name }}
                        props={{
                        onBlur: handleBlur,
                        }}
                    />
                    {touched.name && errors.name && <span style={{ color: 'red' }}>{errors.name}</span>} 
                </div>

                <label htmlFor="staticEmail" className="col-sm-2 col-form-label"> Deskripsi </label>
                <div style={{ paddingBottom: '10px'}}>
                    <input onChange={handleChange}
                        type="text"
                        name="descr"
                        id="descr"
                        className='form-control'
                        value={values.descr}
                        validation={{ touched: touched.descr, errors: errors.descr }}
                        props={{
                        onBlur: handleBlur,
                        }}
                    />
                    {touched.descr && errors.descr && <span style={{ color: 'red' }}>{errors.descr}</span>} 
                </div>
              </div>
            </div>
          </form>
        )}
      </Formik>
    </ModalComponent>
  );
};

export default FormRole;
